module.exports = __webpack_public_path__ + "static/Pt03-eea306673a1912e774ca631c63a20bea.jpg";